module.exports = __webpack_public_path__ + "img/mainback1.838a84b1.jpg";